(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-cl-campaign-video]').forEach((video) => {
      if (video.dataset.ready) return;
      const root = video.closest('.cl-hero');
      const button = root.querySelector('[data-cl-film-toggle]');
      const label = button?.querySelector('[data-cl-film-label]');
      const progress = root.querySelector('[data-cl-film-progress]');
      if (!button || !label) return;
      video.dataset.ready = 'true';
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = motion.matches || !!navigator.connection?.saveData;
      let visible = true;
      const load = () => {
        if (video.getAttribute('src')) return;
        const sources = JSON.parse(video.dataset.clSources || '[]').sort((a, b) => a.width - b.width);
        const needed = Math.min(1280, Math.max(innerWidth, 720));
        const chosen = sources.find((source) => source.width >= needed) || sources[sources.length - 1];
        if (chosen) video.src = chosen.url;
      };
      const update = () => {
        const playing = !video.paused;
        label.textContent = playing ? button.dataset.pause : button.dataset.play;
        button.setAttribute('aria-label', label.textContent);
        button.dataset.playing = String(playing);
      };
      const play = () => {
        load();
        const promise = video.play();
        if (promise?.catch) promise.catch(update);
      };
      button.addEventListener('click', () => {
        userPaused = !video.paused;
        if (userPaused) video.pause(); else play();
      });
      video.addEventListener('playing', () => video.classList.add('is-ready'));
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { video.classList.remove('is-ready'); update(); });
      video.addEventListener('timeupdate', () => {
        if (progress && Number.isFinite(video.duration) && video.duration > 0) progress.value = video.currentTime / video.duration * 100;
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting;
          if (!visible) video.pause(); else if (!userPaused && !document.hidden) play();
        }, { threshold: .12 });
        observer.observe(video);
      } else if (!userPaused) play();
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause(); else if (visible && !userPaused) play();
      });
      motion.addEventListener('change', () => {
        if (motion.matches) { userPaused = true; video.pause(); }
      });
      button.hidden = false;
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
